import styled, {css} from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';

const activeHoveredHeaderItemOpacity = 0.9;

export const SideBarContainer = styled.div`
  height: 100%;
  position: relative;
  z-index: 1;
  background-color: rgb(255, 255, 255);

  @media (min-width: ${device.tablet}) {
    height: 100vh;
    display: block;
    border-right: 1px solid rgba(21, 41, 70, 0.2);
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 0 10px 0 0;
  margin-bottom: 24px;
  align-items: center;
  margin-top: 45px;
  gap: 20px;
  justify-content: space-between;

  @media (min-width: ${device.tablet}) {
    padding: 10px 10px 10px 24px;
    border-bottom: none;
    flex-direction: row;
    gap: 0;
    min-height: 70px;
    margin-top: 0;
  }
`;

export const HeaderImgContainer = styled.div`
  width: 45px;
`;

export const HeaderImg = styled.img`
  width: 100%;
  height: 45px;
  border-radius: 50%;
`;

export const HeaderText = styled.div<{isImageHeader?: boolean}>`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.36px;
  width: ${props => (props.isImageHeader ? 'calc(100% - 60px)' : '100%')};

  /* overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: pre-wrap; */

  @media (min-width: ${device.tablet}) {
    display: block;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const HeaderTooltipOverlay = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  opacity: 0.5;
  background-color: #000;
  left: 0;
  top: 0;
  z-index: 10;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(
    100% - 132px
  ); // this is heigh less menu header padding top, leess paddings
  padding: 0 16px;
  background-color: #fff;
  @media (min-width: ${device.tablet}) {
    height: calc(100% - 95px);
  }

  & .sider-bar-items {
    height: 100%;
  }

  & .side-bar-footer {
    padding: 8px 0 24px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    @media (min-width: ${device.tablet}) {
      padding: 24px 0;
    }
  }
`;

export const ItemContainer = styled.div<{isActive?: boolean}>`
  padding: 8px 12px;
  display: flex;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  border-radius: 6px;
  align-items: center;
  color: #152946;
  cursor: pointer;
  text-transform: capitalize;
  &:not(:last-child) {
    margin-bottom: 8px;
  }

  & .icon {
    margin-right: 12px;
  }

  ${props =>
    props.isActive &&
    css`
      color: #385bf8;
      background-color: #ebebf8;
    `};

  ${props =>
    !props.isActive &&
    css`
      &:hover {
        color: ${props => props.theme.colors.$p0};
        opacity: ${activeHoveredHeaderItemOpacity};
        svg path {
          fill: ${props => props.theme.colors.$p0};
        }
      }
    `};
`;
